import {spawnErrorToast} from '@hm/fundamental'
import type {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {UpmEntityType} from '@refra/modules/common/enums'
import {useRefraQuery} from '@refra/modules/common/hooks'
import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface UseKilnConfigParams {
  plantUpmId: string
  kilnUpmId: string
}

// TODO: might be replaced with the one from kilnfeature
// (https://jira.heidelbergcement.com/browse/HCP-97660)
export const useKilnConfig = ({plantUpmId, kilnUpmId}: UseKilnConfigParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'assetConfig',
    params: [
      {
        plantUpmId,
        assetUpmType: UpmEntityType.Department,
        assetUpmId: kilnUpmId
      }
    ],
    staleTime: Infinity,
    retry: false,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status

      // 404 means kiln config is missing and user is proposed to set it up
      if (axiosError.response?.status !== 404) {
        logger
          .context('useKilnConfig')
          .extras({errorDetails, plantUpmId, kilnUpmId})
          .error('Error occurred while fetching kiln config')

        spawnErrorToast(t('error.kilnConfigQuery'))
      }

      return false
    }
  })
}
